import { API_URL } from '@api/apiDictionary';
import { QCPatientVisitDates } from '@dynamika-shared/types/visits';
import { faker } from '@faker-js/faker';
import { axiosMock } from '@api/client';

export const fetchQCPatientVisitsDatesMock = () => {
  const visits: QCPatientVisitDates[] = Array.from({ length: 3 }).map(
    (_, i) => ({
      id: faker.string.uuid(),
      visitDefinitionId: faker.string.uuid(),
      visitName: `Visit ${i + 1}`,
      taskId: faker.string.uuid(),
      visitOrder: i + 1,
      visitOrderLocked: faker.datatype.boolean(),
      canUnlockVisitOrder: faker.datatype.boolean(),
      visitDate: faker.date.past().toISOString().split('T')[0],
      forecastDate: faker.date.future().toISOString().split('T')[0],
      assetAcquisitionDate: faker.date.past().toISOString().split('T')[0],
      edtfAcquisitionDate: faker.date.future().toISOString().split('T')[0],
      uploadDate: faker.date.recent().toISOString(),
    })
  );

  const data = {
    clinicalTrialId: faker.string.uuid(),
    siteId: faker.string.uuid(),
    patientId: faker.string.uuid(),
    visits,
  };

  axiosMock
    .onGet(new RegExp(`${API_URL.qcPatientVisitsDates.replace(':id', '.*')}`))
    .reply(200, data);
};
